// 当前前台是否为开发模式
const isDev = process.env.NODE_ENV === 'development1'
let echartsUrl = isDev ? 'http://192.168.0.162:8100' : 'https://m.bjftyx.net/agent-api'
export default {
    echartsUrl: echartsUrl,
    isDev: true,
  }